import { ApiService } from '@core/http';
import { takeUntil } from 'rxjs';
import { createElement } from 'src/app/core/helpers/dom';
import { getSvg } from 'src/app/core/helpers/get-svg';
import { onElementDestroy } from 'src/app/core/helpers/on-element-destroy';
import { translate } from 'src/app/project/features/translate/translate';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { bulkGroup } from '../../../site-options/bulk-group-button/bulk-group';
import { bulkUngroup } from '../../../site-options/bulk-group-button/bulk-ungroup';
import { checkIfAllGroupsCollapsed } from '../../../site-options/bulk-group-button/check-if-all-groups-collapsed';
import { getGroupsChange$ } from '../../../site-table/table.ui.store';
import { GET_TIMELINE } from '../../timeline.ui.store';
import { createTimelineCellElement } from '../body-cells/create-timeline-cell-element';
import { createTimelineResizeElement } from '../resize-element';
import { iconMap } from 'src/app/project/shared/enums/icon-map';

export function createHeaderEmptyElement(
  apiService: ApiService,
  addCollapseExpandButton: boolean,
): HTMLElement {
  const selectElement = createElement('div', {
    attrs: {
      class: ['timelineColumnWidth'],
    },
  });

  const resizeElement = createTimelineResizeElement();

  const element = createTimelineCellElement({
    className: 'timeline__emptyHead timelineColumnWidth',
    center: true,
    child: selectElement,
  });

  element.appendChild(resizeElement);

  if (addCollapseExpandButton) {
    const collapseExpandElement = createHeaderCollapseExpandElement(apiService);
    element.appendChild(collapseExpandElement);
  }

  return element;
}

function createHeaderCollapseExpandElement(apiService: ApiService): HTMLElement {
  const allCollapsed = checkIfAllGroupsCollapsed(GET_TIMELINE());
  const iconPath = allCollapsed
    ? EIconPath.ICON_TABLE_EXPAND_ALL
    : EIconPath.ICON_TABLE_COLLAPSE_ALL;

  const iconWrapper = createIconWrapper(iconPath);

  const textElement = createTextElement();

  const element = createElement('div', {
    attrs: {
      class: ['timeline__collapseExpand'],
    },
    children: [iconWrapper, textElement],
    eventListeners: {
      click: () => {
        bulkGroupClickHandler();
      },
    },
  });

  getGroupsChange$()
    .pipe(takeUntil(onElementDestroy(element)))
    .subscribe(() => {
      applyCollapsedState(textElement, iconWrapper);
    });

  applyCollapsedState(textElement, iconWrapper);

  setTimeout(() => {
    applyCollapsedState(textElement, iconWrapper);
  }, 100);

  return element;
}

function bulkGroupClickHandler(): void {
  if (checkIfAllGroupsCollapsed(GET_TIMELINE())) {
    bulkUngroup(GET_TIMELINE());
  } else {
    bulkGroup(GET_TIMELINE());
  }
}

function createTextElement(): HTMLElement {
  return createElement('span', {
    attrs: {
      class: 'timeline__collapseExpand__text',
    },
  });
}

function createIconWrapper(iconPath: EIconPath): HTMLElement {
  return createElement('div', {
    attrs: {
      class: 'table__headerOptions__button',
    },
    children: [
      createElement('img', {
        attrs: {
          src: iconPath,
        },
      }),
    ],
  });
}

function applyCollapsedState(textElement: HTMLElement, iconWrapper: HTMLElement): void {
  const allCollapsed = checkIfAllGroupsCollapsed(GET_TIMELINE());
  const iconPath = allCollapsed
    ? EIconPath.ICON_TABLE_EXPAND_ALL
    : EIconPath.ICON_TABLE_COLLAPSE_ALL;
  textElement.innerHTML = allCollapsed ? translate('expand_all') : translate('collapse_all');

  const svg = iconMap[iconPath];

  iconWrapper.innerHTML = svg;
}
